import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import i18n from 'i18n';
import * as termsActions from 'redux/ducks/Terms/TermsDucks';

export const UseTerms = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const sch = location.search;
  const searchParams = new URLSearchParams(sch);
  const langCd = searchParams.get('langCd');
  const { trmsCd, useTerms, currentVersion } = useSelector(state => state.terms);
  const [langIdx, setLangIdx] = useState(!langCd || langCd === 'ko' ? 0 : 1);
  const [currentTerm, setCurrentTerm] = useState([]);
  // const langCd = getLanguage();
  useEffect(() => {
    dispatch(termsActions.getUseTermsVersion({ trmsCd: 'SVCRKR', noSessionPrc: 'Y' }));
  }, []);

  useEffect(() => {
    if (trmsCd?.trmsCd) {
      dispatch(
        termsActions.getUseTerms({
          trmsCd: 'SVCRKR',
          noSessionPrc: 'Y',
          trmsVerVal: trmsCd.trmsVerVals[trmsCd.trmsVerVals.length - 1],
        }),
      );
    } else if (trmsCd?.errorCode) {
      navigate.replace('/uersapp/error');
    }
  }, [trmsCd]);

  useEffect(() => {
    if (useTerms) {
      setCurrentTerm(useTerms.filter(values => values.trmsVerVal === trmsCd.trmsVerVals[currentVersion]));
    }
  }, [useTerms]);

  return (
    <section className="window-pop-container md-1 window--member scroll-show">
      <div className="window-contents">
        <div className="window-header al-space">
          <h1 className="page-title">Brity Works {i18n.t('MB_T_USE_TERMS')}</h1>
          <div className="title-side">
            <div className="tabs">
              <div className="tabs-segment">
                <ul className="tabs-group sm">
                  <li>
                    <button
                      type="button"
                      data-btn-lang="ko"
                      className={`tab-link ${langIdx === 0 && `active`}`}
                      onClick={() => {
                        setLangIdx(0);
                      }}
                    >
                      {useTerms[0]?.langNm}
                    </button>
                  </li>
                  {useTerms.length > 1 && (
                    <li>
                      <button
                        type="button"
                        data-btn-lang="en"
                        className={`tab-link ${langIdx === 1 && `active`}`}
                        onClick={() => {
                          setLangIdx(1);
                        }}
                      >
                        {useTerms[1]?.langNm}
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="window-body">
          <div className="body-container">
            <div className="section--login">
              <div className="terms">
                <div
                  className="section--terms"
                  dangerouslySetInnerHTML={{
                    __html: currentTerm[langIdx] && currentTerm[langIdx]?.trmsCn,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseTerms;
